<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div class="pt-1">
                  <login-jwt></login-jwt>
                </div>

                <!-- <vs-tabs>
                  <vs-tab label="JWT">
                    <login-jwt></login-jwt>
                  </vs-tab>

                  <vs-tab label="Firebase">
                    <login-firebase></login-firebase>
                  </vs-tab>

                  <vs-tab label="Auth0">
                    <login-auth0></login-auth0>
                  </vs-tab>
                </vs-tabs> -->
                <div class="mb-1 mt-1" style="position:absolute; bottom:0">
                  <span style="position:relative; bottom: 8px;right: 5px; font-size: 1.1rem;">Internet status:</span>
                  <feather-icon v-if="hasInternet" icon="WifiIcon" svgClasses="stroke-current text-success w-8 h-8" class="ml-2" /> 
                  <feather-icon v-else icon="WifiOffIcon" svgClasses="stroke-current text-danger w-8 h-8" class="ml-2" /> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'
// import LoginFirebase from './LoginFirebase.vue'
// import LoginAuth0 from './LoginAuth0.vue'

export default {
  components: {
    LoginJwt,
    // LoginFirebase,
    // LoginAuth0
  },
  data () {
    return {
      hasInternet: navigator.onLine,
    }
  },
  created () {
    let self = this
    window.addEventListener('offline', function(e) { 
      self.hasInternet = false
      console.log('offline'); 
    });

    window.addEventListener('online', function(e) { 
      self.hasInternet = true
      console.log('online'); 
    });
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
